import { AuthService } from "../shared/services/AuthService.js";
import { FirebaseService } from "../shared/services/FirebaseService.js";
import { AppConfig } from "../shared/config/AppConfig.js";
import { ApiService } from "../shared/services/ApiService.js";
import { TemplateEngine } from "../shared/utils/TemplateEngine.js";
import { VehicleSelectModule } from "../shared/components/VehicleSelectModule.js";

import { LocationSelectModule } from "../shared/components/LocationSelectModule.js";
import { SupportDialog } from "../shared/components/SupportDialog.js";

import loginTemplate from "./templates/login.html?raw";
import registerTemplate from "./templates/register.html?raw";
import forgotPasswordTemplate from "./templates/forgot-password.html?raw";
import activateTemplate from "./templates/activate.html?raw";
import completarPerfilTemplate from "./templates/completar-perfil.html?raw";

import Swal from "sweetalert2";

// Datos del usuario social pendiente de completar perfil
let _socialData = null;
// Lista completa de condiciones IVA (para re-filtrar según EsEmpresa)
let _allCondicionesIVA = [];

function firebaseErrorMessage(error) {
	const code = error?.code || "";
	if (code === "auth/user-not-found" || code === "auth/invalid-credential" || code === "auth/wrong-password") {
		return "Email o contraseña incorrectos";
	}
	if (code === "auth/too-many-requests") {
		return "Demasiados intentos fallidos. Intentá más tarde";
	}
	if (code === "auth/invalid-email") {
		return "El email ingresado no es válido";
	}
	if (code === "auth/popup-closed-by-user" || code === "auth/cancelled-popup-request") {
		return null; // usuario canceló — no mostrar error
	}
	return "Error al autenticar. Intentá de nuevo";
}

function bindSupportLink() {
	document.getElementById("lnkSupport")?.addEventListener("click", (e) => {
		e.preventDefault();
		SupportDialog.open();
	});
}

export const AuthController = {
	currentStep: 1,
	totalSteps: 4,

	renderLogin: () => {
		const data = {
			logoUrl: AppConfig.external.logoUrl,
			appName: AppConfig.app.name,
			authFacebook: AppConfig.features.authFacebook,
			authApple: AppConfig.features.authApple,
		};

		document.getElementById("app").innerHTML = TemplateEngine.render(loginTemplate, data);
		document.getElementById("loginForm").addEventListener("submit", AuthController.handleLogin);
		document.getElementById("btnLoginGoogle").addEventListener("click", AuthController.handleLoginGoogle);
		document.getElementById("btnLoginFacebook")?.addEventListener("click", AuthController.handleLoginFacebook);
		document.getElementById("btnLoginApple")?.addEventListener("click", AuthController.handleLoginApple);
		bindSupportLink();
	},

	renderRegister: () => {


		const data = {
			logoUrl: AppConfig.external.logoUrl,
			appName: AppConfig.app.name,
			termsUrl: AppConfig.app.termsUrl,
			maxYear: new Date().getFullYear(),
			minYear: new Date().getFullYear() - 40,
			currentMonth: new Date().toISOString().slice(0, 7),
		};

		document.getElementById("app").innerHTML = TemplateEngine.render(registerTemplate, data);

		// Configurar wizard
		AuthController.setupWizard();

		// Mostrar el primer paso
		AuthController.currentStep = 1;
		AuthController.updateStepDisplay();

		// Cargar datos iniciales
		AuthController.loadInitialData();

		document.getElementById("registerForm").addEventListener("submit", AuthController.handleRegister);
		bindSupportLink();
	},

	renderCompletarPerfil: async () => {
		if (!_socialData) {
			window.location.hash = "login";
			return;
		}

		// Split del displayName de Google en nombre y apellido
		const fullName = (_socialData.nombre || "").trim();
		const nameParts = fullName ? fullName.split(" ") : [];
		const apellido = nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";
		const nombres = nameParts.length > 1 ? nameParts.slice(0, -1).join(" ") : fullName;

		const data = {
			logoUrl: AppConfig.external.logoUrl,
			appName: AppConfig.app.name,
			termsUrl: AppConfig.app.termsUrl,
			email: _socialData.email,
			nombres,
			apellido,
			provider: _socialData.provider || "tu cuenta social",
			maxYear: new Date().getFullYear(),
			minYear: new Date().getFullYear() - 40,
			currentMonth: new Date().toISOString().slice(0, 7),
		};

		document.getElementById("app").innerHTML = TemplateEngine.render(completarPerfilTemplate, data);

		AuthController.currentStep = 1;
		AuthController.totalSteps = 3;
		AuthController.setupWizard();
		AuthController.updateStepDisplay();

		await AuthController.loadInitialDataSocial();

		document.getElementById("completarPerfilForm").addEventListener("submit", AuthController.handleCompletarPerfil);
	},

	setupWizard: () => {
		const nextBtn = document.getElementById("nextBtn");
		const prevBtn = document.getElementById("prevBtn");

		nextBtn.addEventListener("click", AuthController.nextStep);
		prevBtn.addEventListener("click", AuthController.prevStep);

		AuthController.updateStepDisplay();
	},

	nextStep: () => {
		if (AuthController.validateCurrentStep()) {
			if (AuthController.currentStep < AuthController.totalSteps) {
				AuthController.currentStep++;
				AuthController.updateStepDisplay();
			}
		}
	},

	prevStep: () => {
		if (AuthController.currentStep > 1) {
			AuthController.currentStep--;
			AuthController.updateStepDisplay();
		}
	},

	updateStepDisplay: () => {
		// Ocultar todos los pasos
		document.querySelectorAll(".step-content").forEach((step) => {
			step.classList.remove("active");
		});

		// Mostrar paso actual
		const currentStepElement = document.querySelector(`.step-content[data-step="${AuthController.currentStep}"]`);
		if (currentStepElement) {
			currentStepElement.classList.add("active");
		}

		// Actualizar indicadores
		document.querySelectorAll(".step-indicator").forEach((indicator, index) => {
			const stepNum = index + 1;
			if (stepNum <= AuthController.currentStep) {
				indicator.classList.remove("bg-secondary");
				indicator.classList.add("bg-primary", "active");
			} else {
				indicator.classList.remove("bg-primary", "active");
				indicator.classList.add("bg-secondary");
			}
		});

		document.querySelectorAll(".progress-bar").forEach((barrita, index) => {
			const stepNum = index + 2; // Comenzar desde 2 porque el primer paso ya está cubierto por el indicador activo
			if (stepNum <= AuthController.currentStep) {
				barrita.style.width = `100%`;
			} else {
				barrita.style.width = `0%`;
			}
		});


		// Mostrar/ocultar botones
		const prevBtn = document.getElementById("prevBtn");
		const nextBtn = document.getElementById("nextBtn");
		const submitBtn = document.getElementById("submitBtn");

		prevBtn.style.display = AuthController.currentStep > 1 ? "block" : "none";

		if (AuthController.currentStep === AuthController.totalSteps) {
			nextBtn.style.display = "none";
			submitBtn.style.display = "block";
		} else {
			nextBtn.style.display = "block";
			submitBtn.style.display = "none";
		}
	},

	validateCurrentStep: () => {
		const currentStepElement = document.querySelector(`.step-content[data-step="${AuthController.currentStep}"]`);
		const requiredFields = currentStepElement.querySelectorAll("[required]");
		let isValid = true;
		requiredFields.forEach((field) => {
			if (!field.value.trim()) {
				field.classList.add("is-invalid");
				isValid = false;
			} else {
				field.classList.remove("is-invalid");
			}
		});

		if (AuthController.currentStep === 1) {
			const documentoField = document.querySelector('[name="documento"]');
			if (documentoField) {
				const cuitValido = AuthController.validateCuit(documentoField.value);
				if (!cuitValido) {
					Swal.fire("Error", "El CUIT ingresado no es válido", "error");
					return false;
				}
			}
		}

		if (AuthController.currentStep === 3) {
			const anioVehiculo = document.querySelector('[name="anio"]')?.value;
			if (anioVehiculo !== undefined) {
				const maxYear = new Date().getFullYear();
				const minYear = maxYear - 40;
				if (anioVehiculo < minYear || anioVehiculo > maxYear) {
					Swal.fire("Error", "El año del vehículo debe estar entre " + minYear + " y " + maxYear, "error");
					return false;
				}

				const dominioVehiculo = document.querySelector('[name="dominio"]').value;
				if (dominioVehiculo.length !== 6 && dominioVehiculo.length !== 7) {
					Swal.fire("Error", "El dominio parece incorrecto", "error");
					return;
				}
			}
		}

		if (!isValid) {
			Swal.fire("Error", "Por favor complete todos los campos requeridos", "error");
		}

		return isValid;
	},

	validateCuit: (txtCuit) => {
		var nCuit = txtCuit.trim();
		nCuit = nCuit.replace(/-/g, "");
		nCuit = nCuit.replace(/\./g, "");
		nCuit = nCuit.replace(/\//g, "");
		nCuit = nCuit.replace(/,/g, "");
		var Sumatoria = 0;
		var ListaMultiplicacion = new Array(5, 4, 3, 2, 7, 6, 5, 4, 3, 2);

		var IsNumeric = nCuit - 0 == nCuit && nCuit.length > 0;
		if (!IsNumeric || nCuit.length !== 11) {
			return false;
		}
		for (var i = 0; i <= 9; i++) {
			Sumatoria = Sumatoria + parseInt(nCuit.substring(i, i + 1)) * ListaMultiplicacion[i];
		}
		var ModSumatoria = Sumatoria % 11;
		var dVerific = ModSumatoria;
		if (ModSumatoria > 0) {
			dVerific = 11 - ModSumatoria;
		}
		if (parseInt(nCuit.substring(10, 11)) === dVerific) {
			return true;
		} else {
			return false;
		}

	},

	loadInitialData: async () => {
		try {


			// Cargar condiciones IVA
			const conditionsIVA = await AuthController.loadCondicionesIVA();
			AuthController.populateSelect("selectCondicionIVA", conditionsIVA);


			// Cargar colores
			const colores = await AuthController.loadColores();
			AuthController.populateSelect("selectColor", colores);



			// ✅ Selector vehículo reusable (Marca/Modelo/Vehículo)
			await VehicleSelectModule.mount({
				root: document,
				selectMarca: "#selectMarca",
				selectModelo: "#selectModelo",
				selectVehiculo: "#selectVehiculo",
				placeholderMarca: "Marca",
				placeholderModelo: "Modelo",
				placeholderVehiculo: "Versión",
			});

			await LocationSelectModule.mount({
				root: document,
				selectPais: "#selectPais",
				selectProvincia: "#selectProvincia",
				selectLocalidad: "#selectLocalidad",
				placeholderPais: "País",
				placeholderProvincia: "Provincia",
				placeholderLocalidad: "Localidad",
			});

			AuthController.setupPersonaJuridicaToggle();

			const anioInput = document.querySelector('[name="anio"]');
			const fechaAdqInput = document.getElementById('inputFechaAdquisicion');
			if (anioInput && fechaAdqInput) {
				anioInput.addEventListener('input', () => {
					if (anioInput.value) fechaAdqInput.min = anioInput.value + '-01';
				});
			}

		} catch (error) {
			console.error("Error loading initial data:", error);
		}
	},

	loadInitialDataSocial: async () => {
		try {
			const [conditionsIVA, colores] = await Promise.all([
				AuthController.loadCondicionesIVA(),
				AuthController.loadColores()
			]);
			AuthController.populateSelect("selectCondicionIVA", conditionsIVA);
			AuthController.populateSelect("selectColor", colores);

			await VehicleSelectModule.mount({
				root: document,
				selectMarca: "#selectMarca",
				selectModelo: "#selectModelo",
				selectVehiculo: "#selectVehiculo",
				placeholderMarca: "Marca",
				placeholderModelo: "Modelo",
				placeholderVehiculo: "Versión",
			});

			await LocationSelectModule.mount({
				root: document,
				selectPais: "#selectPais",
				selectProvincia: "#selectProvincia",
				selectLocalidad: "#selectLocalidad",
				placeholderPais: "País",
				placeholderProvincia: "Provincia",
				placeholderLocalidad: "Localidad",
			});

			AuthController.setupPersonaJuridicaToggle();

			const anioInputS = document.querySelector('[name="anio"]');
			const fechaAdqInputS = document.getElementById('inputFechaAdquisicion');
			if (anioInputS && fechaAdqInputS) {
				anioInputS.addEventListener('input', () => {
					if (anioInputS.value) fechaAdqInputS.min = anioInputS.value + '-01';
				});
			}
		} catch (error) {
			console.error("Error loading social initial data:", error);
		}
	},

	populateSelect: (selectId, options) => {
		const select = document.getElementById(selectId);
		// Limpiar opciones existentes (excepto la primera)
		while (select.children.length > 1) {
			select.removeChild(select.lastChild);
		}

		options.forEach((option) => {
			const optionElement = document.createElement("option");
			optionElement.value = option.id;
			optionElement.textContent = option.name;
			select.appendChild(optionElement);
		});
	},

	// Funciones para cargar datos desde API

	loadCondicionesIVA: async () => {
		const response = await ApiService.post("condicionesIVA/obtener/");
		if (response.status == 0) {
			const transformada = response.message.map(item => ({
				id: item.id,
				name: item.nombre
			}));
			_allCondicionesIVA = transformada;
			return transformada;
		}
	},


	loadColores: async () => {
		const response = await ApiService.post("colores/obtener/");
		if (response.status == 0) {
			const transformada = response.message.map(item => ({
				id: item.id,
				name: item.nombre
			}));
			return transformada;
		}
	},


	setupPersonaJuridicaToggle: () => {
		const chk = document.getElementById("chkPersonaJuridica");
		if (!chk) return;
		chk.addEventListener("change", () => {
			AuthController.applyPersonaJuridicaUI(chk.checked);
		});
	},

	applyPersonaJuridicaUI: (esEmpresa) => {
		// Cambiar etiquetas del paso 1
		const lblNombres = document.getElementById("lblNombres");
		const lblApellido = document.getElementById("lblApellido");

		// Guardar el texto original la primera vez
		if (lblNombres && !lblNombres.dataset.original) lblNombres.dataset.original = lblNombres.textContent;
		if (lblApellido && !lblApellido.dataset.original) lblApellido.dataset.original = lblApellido.textContent;

		if (lblNombres) lblNombres.textContent = esEmpresa ? "Razón Social *" : (lblNombres.dataset.original || "Nombres *");
		if (lblApellido) lblApellido.textContent = esEmpresa ? "Nombre de Fantasía *" : (lblApellido.dataset.original || "Apellido *");

		// Filtrar condiciones IVA según tipo de persona
		const filteredIVA = esEmpresa
			? _allCondicionesIVA.filter(c => c.name.toLowerCase().includes("responsable inscripto"))
			// Para habilitar Exento en el futuro, agregar la siguiente línea:
			// .concat(_allCondicionesIVA.filter(c => c.name.toLowerCase().includes("exento")))
			: _allCondicionesIVA;
		AuthController.populateSelect("selectCondicionIVA", filteredIVA);
	},

	renderForgotPassword: () => {
		const data = {
			logoUrl: AppConfig.external.logoUrl,
			appName: AppConfig.app.name,
		};

		document.getElementById("app").innerHTML = TemplateEngine.render(forgotPasswordTemplate, data);
		document.getElementById("forgotForm").addEventListener("submit", AuthController.handleForgotPassword);
		bindSupportLink();
	},

	renderActivate: () => {

		const hash = window.location.hash.slice(1) || "";
		const [path, queryString] = hash.split("?");
		const params = queryString ? new URLSearchParams(queryString) : new URLSearchParams();

		// get data in query activate?SecTkn=cccc
		const secTkn = params.get("SecTkn");
		const data = {
			logoUrl: AppConfig.external.logoUrl,
			appName: AppConfig.app.name,
			secTkn
		};

		document.getElementById("app").innerHTML = TemplateEngine.render(activateTemplate, data);
		document.getElementById("activateForm").addEventListener("submit", AuthController.handleActivate);
	},

	handleLogin: async (e) => {
		e.preventDefault();
		const loading = document.querySelector(".loading");
		loading.classList.add("show");

		const email = document.getElementById("email").value;
		const password = document.getElementById("password").value;

		try {
			const result = await AuthService.login(email, password);
			if (result.success) {
				window.location.hash = "dashboard";
				window.location.reload();
			} else {
				Swal.fire("Error", result.message, "error");
			}
		} catch (error) {
			const msg = firebaseErrorMessage(error);
			if (msg) Swal.fire("Error", msg, "error");
		} finally {
			loading.classList.remove("show");
		}
	},

	_handleSocialLogin: async (loginFn, providerName) => {
		try {
			const { idToken, email, displayName, uid } = await loginFn();
			const result = await AuthService.loginWithFirebase(idToken);

			if (result.success && result.perfilIncompleto) {
				_socialData = {
					idToken,
					firebaseUid: result.firebaseUid || uid,
					email: result.email || email,
					nombre: result.nombre || displayName || "",
					provider: providerName,
				};
				window.location.hash = "completar-perfil";
				return;
			}

			if (result.success) {
				window.location.hash = "dashboard";
				window.location.reload();
			} else {
				Swal.fire("Error", result.message || `Error al iniciar sesión con ${providerName}`, "error");
			}
		} catch (error) {
			const msg = firebaseErrorMessage(error);
			if (msg) Swal.fire("Error", msg, "error");
		}
	},

	handleLoginGoogle: () => AuthController._handleSocialLogin(
		() => FirebaseService.loginWithGoogle(), "Google"
	),

	handleLoginFacebook: () => AuthController._handleSocialLogin(
		() => FirebaseService.loginWithFacebook(), "Facebook"
	),

	handleLoginApple: () => AuthController._handleSocialLogin(
		() => FirebaseService.loginWithApple(), "Apple"
	),

	handleRegister: async (e) => {
		e.preventDefault();

		if (!AuthController.validateCurrentStep()) {
			return;
		}

		const loading = document.querySelector(".loading");
		loading.classList.add("show");

		const formData = new FormData(e.target);

		try {

			const finalData = {
				mail: formData.get("mail"),
				persona: {
					apellido: formData.get("apellido"),
					nombres: formData.get("nombres"),
					documento: formData.get("documento"),
					telefono: formData.get("telefono"),
					celular: formData.get("celular"),
					mail: formData.get("mail"),
					idPais: formData.get("idPais"),
					idProvincia: formData.get("idProvincia"),
					idLocalidad: formData.get("idLocalidad"),
					direccion: formData.get("direccion"),
					tipoFiscal: formData.get("idCondicionIVA"),
					esEmpresa: document.getElementById("chkPersonaJuridica")?.checked ? 1 : 0
				},
				vehiculo: {
					idVehiculo: formData.get("idVehiculo"),
					anio: formData.get("anio"),
					dominio: formData.get("dominio"),
					idColor: formData.get("idColor"),
					kilometraje: 0,
					kmMensuales: 1000,
					chasis: ".",
					motor: ".",
					idCompania: 14,
					poliza: "",
					cobertura: "",
					cedula: "",
					titular: true,
					FechaAdquisicion: formData.get("fechaAdquisicion") ? formData.get("fechaAdquisicion") + "-01" : null
				}
			};

			// Send final data to the API
			const result = await AuthService.register(finalData);
			if (result.success) {
				await Swal.fire("Éxito", "Usuario registrado exitosamente. Por favor, revise su correo para activar la cuenta.", "success");
				window.location.hash = "login";
				return;
			}
			Swal.fire("Error", result.message, "error");
		} catch (error) {
			Swal.fire("Error", "Fallo al registrar usuario", "error");
		} finally {
			loading.classList.remove("show");
		}
	},

	handleCompletarPerfil: async (e) => {
		e.preventDefault();

		if (!AuthController.validateCurrentStep()) return;
		if (!_socialData) { window.location.hash = "login"; return; }

		const loading = document.querySelector(".loading");
		loading.classList.add("show");

		const formData = new FormData(e.target);

		try {
			// Refrescar idToken (puede haber expirado)
			const idToken = await FirebaseService.getIdToken();

			const persona = {
				apellido: formData.get("apellido"),
				nombres: formData.get("nombres"),
				documento: formData.get("documento"),
				telefono: formData.get("telefono"),
				celular: formData.get("celular"),
				mail: _socialData.email,
				idPais: formData.get("idPais"),
				idProvincia: formData.get("idProvincia"),
				idLocalidad: formData.get("idLocalidad"),
				direccion: formData.get("direccion"),
				tipoFiscal: formData.get("idCondicionIVA"),
				esEmpresa: document.getElementById("chkPersonaJuridica")?.checked ? 1 : 0
			};

			const vehiculo = {
				idVehiculo: formData.get("idVehiculo"),
				anio: formData.get("anio"),
				dominio: formData.get("dominio"),
				idColor: formData.get("idColor"),
				kilometraje: 0,
				kmMensuales: 1000,
				chasis: ".",
				motor: ".",
				idCompania: 14,
				poliza: "",
				cobertura: "",
				cedula: "",
				titular: true,
				FechaAdquisicion: formData.get("fechaAdquisicion") ? formData.get("fechaAdquisicion") + "-01" : null
			};

			const result = await AuthService.registerSocial(idToken, _socialData.firebaseUid, persona, vehiculo);

			if (result.success) {
				_socialData = null;
				window.location.hash = "dashboard";
				window.location.reload();
			} else {
				Swal.fire("Error", result.message, "error");
			}
		} catch (error) {
			Swal.fire("Error", "Error al completar el registro", "error");
		} finally {
			loading.classList.remove("show");
		}
	},

	handleForgotPassword: async (e) => {
		e.preventDefault();
		const loading = document.querySelector(".loading");
		loading.classList.add("show");

		const email = document.getElementById("email").value;

		try {
			const result = await AuthService.forgotPassword(email);
			if (result.success) {
				Swal.fire("Éxito", result.message, "success").then(() => {
					window.location.hash = "login";
				});
			}
		} catch (error) {
			Swal.fire("Error", "Error al enviar instrucciones", "error");
		} finally {
			loading.classList.remove("show");
		}
	},

	handleActivate: async (e) => {
		e.preventDefault();
		const loading = document.querySelector(".loading");
		loading.classList.add("show");

		const secTkn = document.getElementById("secTkn").value;
		const password = document.getElementById("password").value;
		const confirmPassword = document.getElementById("confirmPassword").value;

		if (password !== confirmPassword) {
			await Swal.fire("Error", "Las contraseñas no coinciden", "error");
			loading.classList.remove("show");
			return;
		}

		try {
			const result = await AuthService.activateAccount(secTkn, password);
			if (result.success) {
				Swal.fire("Éxito", result.message, "success").then(() => {
					window.location.hash = "login";
				});
			} else {
				Swal.fire("Error", result.message, "error");
			}
		} catch (error) {
			Swal.fire("Error", "Error al activar cuenta", "error");
		} finally {
			loading.classList.remove("show");
		}
	},
};
